import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListInvoiceComponent } from './list-invoice/list-invoice.component';
import { NewInvoiceComponent } from './new-invoice/new-invoice.component';
import { ViewInvoiceComponent } from './view-invoice/view-invoice.component';

const routes: Routes = [{
  path: 'invoice', component: ListInvoiceComponent
}, {
  path: 'invoice/:id', component: NewInvoiceComponent
},
{
  path: 'invoice/view/:id', component: ViewInvoiceComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InvoiceRoutingModule { }
